import { create } from "zustand";

import type { User } from "../api/auth";
import { me } from "../api/auth";
import { getAccess } from "../api/client";

interface AuthState {
  user: User | null;
  loading: boolean;
  setUser: (u: User | null) => void;
  bootstrap: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  setUser: (u) => set({ user: u }),
  bootstrap: async () => {
    if (!getAccess()) {
      set({ loading: false });
      return;
    }
    try {
      const u = await me();
      set({ user: u, loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },
}));
